import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UsersCollectionService } from 'src/app/store/store-services';
import { AppStateService } from 'src/app/store/app-state.service';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { combineLatest, Observable, of } from 'rxjs';
import { UserDataModel } from '@modules/auth';
import { MessengerService } from '../messenger.service';
import { Router } from '@angular/router';
import { HttpUserProfileService } from '@services/HttpServices/UserProfileHttpService/http-user-profile.service';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-new-chat-user-search',
  templateUrl: './new-chat-user-search.component.html',
  styleUrls: ['./new-chat-user-search.component.scss']
})
export class NewChatUserSearchComponent implements OnInit, OnDestroy {

  @ViewChild('searchPan', {static: true}) searchPan!: TemplateRef<HTMLElement>;
  @Output() onClick: EventEmitter<void> = new EventEmitter();
  @Input() private onlineUsers: Observable<UserDataModel[]>;

  public searchForm: FormGroup;
  public searchKey = '';

  private allUsers$: Observable<UserDataModel[]> | Store<UserDataModel[]>;

  constructor(
    private usersService: UsersCollectionService,
    public httpUserProfileService: HttpUserProfileService,
    private appStateService: AppStateService,
    private fb: FormBuilder,
    public messengerService: MessengerService,
    private router: Router,
  ) {
    this.allUsers$ = this.usersService.entities$;
  }

  public ngOnInit(): void {
    this.initForm();
  }

  public ngOnDestroy(): void {}

  public get userList(): Observable<UserDataModel[] | undefined> {
    return combineLatest([this.allUsers$, this.onlineUsers]).pipe(
      map(([users, onlineUsers]: [UserDataModel[], UserDataModel[]]) => {
        if (!this.form?.searchKey?.value) 
          return onlineUsers?.sort((a: UserDataModel, b: UserDataModel) => {
            return a.userName.localeCompare(b.userName)
          });

        const searchValue = this.form.searchKey.value.toLowerCase();
        return users.filter((user: UserDataModel) => (
          this.checkIsInclude(searchValue, user.userName) ||
          this.checkIsInclude(searchValue, user.firstName) ||
          this.checkIsInclude(searchValue, user.lastName)
        ))?.sort((a: UserDataModel, b: UserDataModel) => {
          const isA = this.checkIsInclude(searchValue, a.userName);
          const isB = this.checkIsInclude(searchValue, b.userName);
          if (isA && isB)return a.userName.indexOf(searchValue) - b.userName.indexOf(searchValue);
          if (isA) return -1;
          if (isB) return 1;
          return a.userName.localeCompare(b.userName);
          
        });
      }),
    )
  }

  public openUrl(url: string) {
    this.onClick.next();
    this.router.navigateByUrl(url)
  }

  get form() {
    return this.searchForm.controls;
  }

  public resetSearch() {
    this.form.searchKey.setValue('');
  }

  public getUniqueName(userId) {
    return this.messengerService.getOne2OneConversationUniqueName(userId);
  }

  private checkIsInclude(searchValue: string, checkValue?: string): boolean {
    return !!checkValue && checkValue.toLowerCase().includes(searchValue);
  }

  private initForm() {
    this.searchForm = this.fb.group({
      searchKey: [''],
    });
  }
}
